import { ParsedLegifranceLink } from '@livv/models';
import { Box, Typography } from '@mui/material';
import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';
import SideContentCard from '@components/SideContentCard';

interface PreviousTextsProps {
    lienConcordes: ParsedLegifranceLink[];
}

const PreviousTexts: FC<PreviousTextsProps> = ({ lienConcordes }) => {
    const { t } = useTranslation('codeArticle');

    return (
        <SideContentCard
            sx={{ mb: 1.5 }}
            title={t('previousTexts', { count: lienConcordes.length })}
        >
            {lienConcordes.length === 1 ? (
                <Typography color="grey.300" variant="body1">
                    {lienConcordes[0].textTitle}
                </Typography>
            ) : (
                <Box component="ul" sx={{ m: 0, pl: 3 }}>
                    {lienConcordes.map((lienCitation) => (
                        <Typography
                            key={lienCitation.textCid}
                            color="grey.300"
                            component="li"
                            variant="body1"
                        >
                            {lienCitation.textTitle}
                        </Typography>
                    ))}
                </Box>
            )}
        </SideContentCard>
    );
};

export default PreviousTexts;
